import { useMemo } from "react";
import { useCarConfigSelector } from "../redux/store";
import type { WinterWheelType } from "../../../../common-deprecated/types/CommonTypes";
import type { StatusEntryType } from "../../../../common-deprecated/components/modals/status/StatusModalEntry";
import { winterWheelsDebugFormatter } from "../../../../common-deprecated/features/apheleia/utils/debugModalUtils";

type UseAphWinterWheelsType = {
    entries: StatusEntryType[];
};

const useAphWinterWheels = (): UseAphWinterWheelsType => {
    const winterWheels = useCarConfigSelector((state) => state.items.winterWheels);

    const { completeWinterWheels, incompleteWinterWheels } = useMemo(() => {
        const complete = winterWheels?.filter((wheel) => wheel.valid) ?? [];
        const incomplete = winterWheels?.filter((wheel) => !wheel.valid) ?? [];
        return { completeWinterWheels: complete, incompleteWinterWheels: incomplete };
    }, [winterWheels]);

    const createWheelEntries = (wheels: WinterWheelType[]): StatusEntryType["values"] =>
        winterWheelsDebugFormatter(wheels).map((winterWheel) => ({
            label: `${winterWheel.name} - ${winterWheel.setPartNumber}`,
            collapsibleContent: JSON.stringify(winterWheel, undefined, 2),
        }));

    const entries: StatusEntryType[] = [
        {
            title: "General info",
            description: "",
            values: [
                { label: "Total amount of winter wheels", value: winterWheels?.length.toString() },
                { label: "Valid winter wheels", value: completeWinterWheels?.length.toString() },
                { label: "Invalid winter wheels", value: incompleteWinterWheels?.length.toString() },
            ],
        },
        {
            title: "Invalid winter wheels",
            description: "All winter wheels that are not shown in the configurator due to missing/wrong data",
            values: createWheelEntries(incompleteWinterWheels),
        },
        {
            title: "Valid winter wheels",
            description: "All winter wheels that are shown in the configurator",
            collapsibleContent: {
                values: createWheelEntries(completeWinterWheels),
            },
        },
    ];

    return {
        entries,
    };
};

export default useAphWinterWheels;
